var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open"},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"btn"},[_c('img',{staticClass:"btn_image",attrs:{"src":require("../../../assets/images/active/login.png"),"alt":""}}),_vm._v(" "),_c('p',{staticClass:"font"},[_vm._v("挑选上架商品")]),_vm._v(" "),_c('div',{staticClass:"mocen",on:{"click":_vm.choiceGoods}})])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ee70434","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/active/view/start.vue
// module id = null
// module chunks = 